/**
 * Unit Conversion - Backend API Adapter
 * 
 * This file replaces the old local unit conversion logic.
 * All conversions now happen on the backend!
 */

/**
 * Convert units - Backend handles this now!
 */
export function convertUnits(
  value: number,
  fromUnit: string,
  toUnit: string,
  options?: { servingWeightGrams?: number; productName?: string }
): number | null {
  // Backend already converted units
  return value
}

/**
 * Get serving weight for a product
 */
export function getServingWeight(productName: string): number {
  // Default serving weight (18g powder)
  return 18
}
